import { questions, results } from "./TestQuestion";

export default class Test {
  constructor(startButton) {
    this.startButton = startButton;
    this.restartButton = document.getElementById('restart-btn');
    this.questionContainer = document.getElementById('question');
    this.questionElement = document.getElementById('questionList');
    this.answerButtonsElement = document.getElementById('answer-buttons');
    this.resultContainer = document.getElementById('result');
    this.resultName = document.getElementById('result-name');
    this.resultEgName = document.getElementById('result-egname');
    this.resultText = document.getElementById('result-text');
    this.resultImg = document.getElementById('result-img');
    this.scoreElement = document.getElementById('score');
    this.recommendElement = document.getElementById('result-recommend');
    this.numberElement = document.getElementById('result-number');
    this.scoreArray = [];
    this.currentQuestionIndex = 0;
  }

  startQuiz() {
    this.resultContainer.classList.add('hide');
    this.questionContainer.classList.remove('hide');
    this.showQuestion();
  }

  showQuestion() {
    const currentQuestion = questions[this.currentQuestionIndex];
    this.questionElement.innerText = currentQuestion.question;

    currentQuestion.answers.forEach(answer => {
      const button = document.createElement('button');
      button.innerText = answer.text;
      button.dataset.value = answer.value;
      this.answerButtonsElement.appendChild(button);
      button.addEventListener('click', () => this.selectAnswer(answer.value));
    });
  }

  selectAnswer(value) {
    this.scoreArray.push(parseInt(value));
    
    if (this.currentQuestionIndex === 0) {
      if (value === 1) {
        this.currentQuestionIndex = 1; 
        this.resetState();
        this.showQuestion();
      } else if (value === 2) {
        this.currentQuestionIndex = 2; 
        this.resetState();
        this.showQuestion();
      }
    }
    if (this.currentQuestionIndex === 1) {
      if (value === 3) {
        this.currentQuestionIndex = 3; 
        this.resetState();
        this.showQuestion();
      } else if (value === 4) {
        this.currentQuestionIndex = 4; 
        this.resetState();
        this.showQuestion();
      }
    }
    if (this.currentQuestionIndex === 2) {
      if (value === 5) {
        this.currentQuestionIndex = 5; 
        this.resetState();
        this.showQuestion();
      } else if (value === 6) {
        this.currentQuestionIndex = 6; 
        this.resetState();
        this.showQuestion();
      }
    }

    
    if (this.currentQuestionIndex === 3) {
      if (value === 7 || value === 8) {
        this.showResult();
      }
    } else if (this.currentQuestionIndex === 4) {
      if (value === 9 || value === 10) {
        this.showResult();
      }
    } else if (this.currentQuestionIndex === 5) {
      if (value === 11 || value === 12) {
        this.showResult();
      }
    } else if (this.currentQuestionIndex === 6) {
      if (value === 13 || value === 14) {
        this.showResult();
      }
    }

  }

  resetState() {
    while (this.answerButtonsElement.firstChild) {
      this.answerButtonsElement.removeChild(this.answerButtonsElement.firstChild);
    }
  }

  showResult() {
    this.questionContainer.classList.add('hide');
    this.resultContainer.classList.remove('hide');

    const totalScore = this.scoreArray.reduce((sum, currentValue) => sum + parseInt(currentValue), 0);

    let resultIndex = 0;

    if (totalScore >= 11) {
      resultIndex = 0;
    } else if (totalScore >= 12) {
      resultIndex = 1;
    } else if (totalScore >= 14) {
      resultIndex = 5;
    } else if (totalScore >= 15) {
      resultIndex = 0;
    } else if (totalScore >= 18){
      resultIndex = 2;
    } else if (totalScore >= 19){
      resultIndex = 3;
    } else if (totalScore >= 21){
      resultIndex = 4;
    } else if (totalScore >= 22){
      resultIndex = 5;
    }

    const result = results[resultIndex];
    this.resultText.innerText = result.text + totalScore;

    this.showResultText();
  }

  showResultText() {
    // Implement this function on each page to display the specific result text
  }

  restartQuiz() {
    this.resultContainer.classList.add('hide');
    this.currentQuestionIndex = 0;
    this.scoreArray = [];
    this.resetState();
    this.startQuiz()
  }

  showResultText() {
    const totalScore = this.scoreArray.reduce((sum, currentValue) => sum + parseInt(currentValue), 0);
    for (let i = 0; i < results.length; i++) {
      const result = results[i];

      const showContents = () => {
        this.resultName.innerText = result.name;
        this.resultEgName.innerText = result.egname;
        this.resultText.innerText = result.text;
        this.numberElement.innerText = result.number;
        this.recommendElement.innerText = result.recommend;
        this.resultImg.src = result.img;
        this.numberElement.src = result.number;
      }

      if (totalScore === 14 && i === 5) {
        showContents()
        break;
      } else if (totalScore === 22 && i === 5) {
        showContents()
        break;
      } else if (totalScore === 21 && i === 4) {
        showContents()
        break;
      } else if (totalScore === 19 && i === 3){
        showContents()
        break;
      } else if (totalScore === 18 && i === 2){
        showContents()
        break;
      } else if (totalScore === 12 && i === 1){
        showContents()
        break;
      } else if (totalScore === 11 && i === 0){
        showContents()
        break;
      } else if (totalScore === 15 && i === 0){
        showContents()
        break;
      }
    }

    this.restartButton.addEventListener('click', () => this.restartQuiz());
  }
}
